module.exports = __webpack_public_path__ + "static/media/Lato-Light.96b78ec9.woff2";